<template>
  <section class="details-schedule">
    <Breadcrumb :links="links" />
    <div class="details-schedule__header">
      <div class="card-list-status">
        <div class="change-status">
          <button
            class="change-status__btn"
            @click="handleClickStatus('needsAction')"
          >
            <p>Pendente</p>
            <IconSchedulePending />
          </button>
          <button
            class="change-status__btn change-status__btn--canceled"
            @click="handleClickStatus('declined')"
          >
            <p>Cancelar</p>
            <IconScheduleCanceled />
          </button>
          <button
            class="change-status__btn change-status__btn--confirmed"
            @click="handleClickStatus('accepted')"
          >
            <p>Confirmar</p>
            <IconScheduleConfirmed />
          </button>
          <button
            class="change-status__btn change-status__btn--concluded"
            @click="handleClickStatus('concluded')"
          >
            <p>Concluir</p>
            <IconScheduleConcluded />
          </button>
        </div>
        <div class="card-list-schedule-status" :class="classStatus">
          <b class="font-extra-bold mr-1">STATUS:</b> {{ textStatus }}
        </div>
      </div>
      <div class="card-list-information">
        <div class="card-list-schedule__div">
          <p class="card-list-schedule__type">Paciente:</p>
          <div class="card-list-schedule__element">
            <div class="card-list-schedule__photo">
              <img
                class="img-fluid"
                :src="detailsSchedule.user_photo_url"
                :alt="`foto usuário ${detailsSchedule.user_name}`"
                :title="`foto usuário ${detailsSchedule.user_name}`"
              />
            </div>
            <div class="card-list-schedule__information">
              <h2
                v-if="detailsSchedule.user_name"
                class="card-list-schedule__title"
              >
                {{ detailsSchedule.user_name }}
              </h2>
            </div>
          </div>
        </div>
        <div class="card-list-schedule__div">
          <p class="card-list-schedule__type">Profissional:</p>
          <div class="card-list-schedule__element">
            <div class="card-list-schedule__photo">
              <img
                class="img-fluid"
                :src="getPhotoProfile"
                :alt="`foto professional ${detailsSchedule.professional_name}`"
                :title="`foto professional ${detailsSchedule.professional_name}`"
              />
            </div>
            <div class="card-list-schedule__information">
              <h2
                class="card-list-schedule__title"
                v-if="hasCodeNameOrNameProfessional"
              >
                {{
                  detailsSchedule?.professional_code_name ||
                  detailsSchedule?.professional_name
                }}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="details-schedule__body">
      <div class="details-schedule-hour">
        <h2>Dia e horário:</h2>
        <div class="details-schedule-hour__info">
          <img
            class="img-fluid"
            src="@/assets/img/time-and-calendar.png"
            alt="icon time and calendar"
            title="icon time and calendar"
          />
          <p>{{ detailsSchedule.schedule_date_time | dateTimeFormat }}</p>
        </div>
      </div>
      <div class="details-schedule-hour">
        <h2>Tempo de consulta:</h2>
        <div class="details-schedule-hour__info">
          <img
            class="img-fluid"
            src="@/assets/img/despertador.png"
            alt="icon clock"
            title="icon clock"
          />
          <p>{{ detailsSchedule.service_slot_time | timeFormat }}</p>
        </div>
      </div>
      <div class="details-schedule__reason">
        <h2>Motivo da consulta:</h2>
        <p>{{ detailsSchedule.reason_consultation }}</p>
      </div>
      <div v-if="hasSpecialties" class="details-schedule-specialties">
        <div class="details-schedule-specialties__header">
          <h2>Especialidades:</h2>
        </div>
        <div class="details-schedule-specialties__body">
          <div
            class="details-schedule-specialties__item"
            v-for="specialties in detailsSchedule.specialties"
            :key="specialties.id"
          >
            {{ specialties.name }}
          </div>
        </div>
      </div>
      <div class="details-schedule-price">
        <h2>Preço por sessão:</h2>
        <div class="details-schedule-price__info">
          <svg
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1733_968)">
              <path
                d="M6.99984 12.8332C10.2215 12.8332 12.8332 10.2215 12.8332 6.99984C12.8332 3.77817 10.2215 1.1665 6.99984 1.1665C3.77817 1.1665 1.1665 3.77817 1.1665 6.99984C1.1665 10.2215 3.77817 12.8332 6.99984 12.8332Z"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.75 4.9585C8.35042 4.55892 7.64674 4.28098 7 4.26358M7 4.26358C6.23052 4.24287 5.54167 4.59098 5.54167 5.54184C5.54167 7.29183 8.75 6.41683 8.75 8.16683C8.75 9.16491 7.89612 9.59378 7 9.56158M7 4.26358V3.2085M5.25 8.75016C5.62595 9.25142 6.32497 9.53731 7 9.56158M7 9.56158V10.7918"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1733_968">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p>{{ detailsSchedule.price | money }} - {{ getSessionWithText }}</p>
        </div>
      </div>
      <div v-if="hasWhatsApp" class="details-schedule-whatsapp">
        <h2>Whatsapp do profissional:</h2>
        <div class="details-schedule-whatsapp__body">
          <button
            class="details-schedule-whatsapp__btn"
            @click="sendWhatsAppProfessional"
          >
            <img
              class="img-fluid"
              src="@/assets/img/whatsapp-original.png"
              alt="icon whatsapp"
              title="icon whatsapp"
            />
            <p>
              {{ detailsSchedule.professional_number_whats_app }}
            </p>
          </button>
        </div>
      </div>
      <div v-if="hasWhatsAppUser" class="details-schedule-whatsapp">
        <h2>Whatsapp do paciente:</h2>
        <div class="details-schedule-whatsapp__body">
          <button
            class="details-schedule-whatsapp__btn"
            @click="sendWhatsAppUser"
          >
            <img
              class="img-fluid"
              src="@/assets/img/whatsapp-original.png"
              alt="icon whatsapp"
              title="icon whatsapp"
            />
            <p>
              {{ detailsSchedule.user_number_whats_app }}
            </p>
          </button>
        </div>
      </div>
      <div v-if="hasUrlGoogleMeet" class="details-schedule-meet">
        <h2>Link da consulta:</h2>
        <div class="details-schedule-meet__btn">
          <a
            class="btn-google-meet"
            :href="detailsSchedule.url_google_meet"
            target="_blank"
            rel="noopener"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 16.0875V18.75C17.9988 19.1475 17.8404 19.5283 17.5594 19.8094C17.2783 20.0904 16.8975 20.2488 16.5 20.25H6.75V15.75H13.5V12L18 16.0875Z"
                fill="#00AC47"
              />
              <path d="M18 8.25V16.0875L13.5 12V8.25H18Z" fill="#31A950" />
              <path d="M6.75 3.75V8.25H2.25L6.75 3.75Z" fill="#EA4435" />
              <path d="M6.75 8.25H2.25V16.5H6.75V8.25Z" fill="#4285F4" />
              <path
                d="M18 5.25V8.25H17.625L13.5 12V8.25H6.75V3.75H16.5C16.8975 3.75117 17.2783 3.90958 17.5594 4.19063C17.8404 4.47168 17.9988 4.85253 18 5.25Z"
                fill="#FFBA00"
              />
              <path
                d="M6.75 15.75V20.25H3.75C3.35253 20.2488 2.97168 20.0904 2.69063 19.8094C2.40958 19.5283 2.25117 19.1475 2.25 18.75V15.75H6.75Z"
                fill="#0066DA"
              />
              <path
                d="M21.75 6.19506V17.8051C21.75 17.9501 21.7079 18.0921 21.6288 18.2137C21.5497 18.3353 21.437 18.4313 21.3043 18.4901C21.1717 18.5489 21.0249 18.5679 20.8816 18.5448C20.7384 18.5217 20.605 18.4575 20.4975 18.3601L18 16.0876L13.5 12.0001L17.625 8.25006L18 7.91256L20.4975 5.64006C20.605 5.5426 20.7384 5.47843 20.8816 5.45534C21.0249 5.43226 21.1717 5.45126 21.3043 5.51003C21.437 5.56881 21.5497 5.66482 21.6288 5.78643C21.7079 5.90803 21.75 6.04999 21.75 6.19506Z"
                fill="#00AC47"
              />
              <path
                d="M18 7.9126V16.0876L13.5 12.0001L17.625 8.2501L18 7.9126Z"
                fill="#188038"
              />
            </svg>
            <p>Entrar na chamada</p>
          </a>
        </div>
      </div>
      <div v-if="hasTargetAudience" class="details-schedule-target-audience">
        <div class="details-schedule-target-audience__header">
          <h2>Público alvo do profissional:</h2>
        </div>
        <div class="details-schedule-target-audience__body">
          <div
            class="details-schedule-target-audience__item"
            v-for="targetAudience in detailsSchedule.target_audience"
            :key="targetAudience.id"
          >
            {{ targetAudience.name }}
          </div>
        </div>
      </div>
      <div v-if="hasReportPublicOrPrivate" class="details-schedule-report">
        <h2>Relatório(s) do profissional:</h2>
        <div
          v-if="detailsSchedule.professional_report_public"
          class="details-schedule-report__public"
        >
          <h3>Público:</h3>
          <p>{{ detailsSchedule.professional_report_public }}</p>
        </div>
        <div
          v-if="detailsSchedule.professional_report"
          class="details-schedule-report__private"
        >
          <h3>Privado:</h3>
          <p>{{ detailsSchedule.professional_report }}</p>
        </div>
      </div>
      <div
        v-if="hasReasonCancellation"
        class="details-schedule-reason-cancellation"
      >
        <h2>Motivo do cancelamento:</h2>
        <p>{{ detailsSchedule.reason_cancellation }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Breadcrumb from "@/components/breadcrumb/Index";
import IconSchedulePending from "@/components/icons/IconSchedulePending";
import IconScheduleCanceled from "@/components/icons/IconScheduleCanceled";
import IconScheduleConfirmed from "@/components/icons/IconScheduleConfirmed";
import IconScheduleConcluded from "@/components/icons/IconScheduleConcluded";

export default {
  components: {
    Breadcrumb,
    IconSchedulePending,
    IconScheduleCanceled,
    IconScheduleConfirmed,
    IconScheduleConcluded,
  },
  computed: {
    ...mapGetters("Professional", ["detailsSchedule"]),
    getProfessionalNameAndUser() {
      const scheduleFormatted = this.$options.filters.dateTimeFormat(
        this.detailsSchedule.schedule_date_time
      );
      const professionalName =
        this.detailsSchedule?.professional_code_name ||
        this.detailsSchedule?.professional_name;
      const userName = this.detailsSchedule.user_name;

      return `${scheduleFormatted}: ${professionalName} > ${userName}`;
    },
    links() {
      return [
        {
          name: "Profissional",
          routerName: "Professional",
        },
        {
          name: "Listar todos os agendamentos",
          routerName: "ListSchedules",
        },
        {
          name: this.getProfessionalNameAndUser,
          routerName: "ScheduleDetails",
        },
      ];
    },
    hasDetailsSchedule() {
      return (
        this.detailsSchedule && Object.keys(this.detailsSchedule).length > 0
      );
    },
    hasCodeNameOrNameProfessional() {
      return (
        this.hasDetailsSchedule &&
        (this.detailsSchedule?.professional_code_name ||
          this.detailsSchedule?.professional_name)
      );
    },
    getPhotoProfile() {
      return (
        (this.detailsSchedule?.profile_photo_file_path ??
          this.detailsSchedule?.photo_url) ||
        require("@/assets/img/image-user-google.png")
      );
    },
    getSessionWithText() {
      return (
        this.detailsSchedule.session +
        (this.detailsSchedule.session > 1 ? " sessões" : " sessão")
      );
    },
    isConcluded() {
      return this.detailsSchedule.id_status_schedule === 4; // conclúido
    },
    isConfirmed() {
      return this.detailsSchedule.id_status_schedule === 3; // confirmado
    },
    isCanceled() {
      return this.detailsSchedule.id_status_schedule === 2; // cancelado
    },
    isPending() {
      return this.detailsSchedule.id_status_schedule === 1; // pendente
    },
    textStatus() {
      if (this.isConcluded) {
        return "Consulta concluída";
      }

      if (this.isConfirmed) {
        return "Consulta confirmada";
      }

      if (this.isCanceled) {
        return "Consulta cancelada";
      }

      return "Consulta pendente";
    },
    classStatus() {
      if (this.isConcluded) {
        return "card-list-schedule-status--concluded";
      }

      if (this.isConfirmed) {
        return "card-list-schedule-status--confirmed";
      }

      if (this.isCanceled) {
        return "card-list-schedule-status--canceled";
      }

      return "";
    },
    getIconStatus() {
      if (this.isConcluded) {
        return "✅";
      }

      if (this.isConfirmed) {
        return "🟦";
      }

      if (this.isCanceled) {
        return "❌";
      }

      return "⚠️";
    },
    hasUrlGoogleMeet() {
      return this.detailsSchedule.url_google_meet;
    },
    hasReportPublicOrPrivate() {
      return (
        this.detailsSchedule.professional_report_public ||
        this.detailsSchedule.professional_report
      );
    },
    hasWhatsApp() {
      return (
        this.hasDetailsSchedule &&
        this.detailsSchedule?.professional_number_whats_app
      );
    },
    hasWhatsAppUser() {
      return (
        this.hasDetailsSchedule && this.detailsSchedule?.user_number_whats_app
      );
    },
    hasSpecialties() {
      return (
        this.hasDetailsSchedule &&
        this.detailsSchedule?.specialties &&
        Array.isArray(this.detailsSchedule.specialties) &&
        this.detailsSchedule.specialties.length > 0
      );
    },
    hasTargetAudience() {
      return (
        this.hasDetailsSchedule &&
        this.detailsSchedule?.target_audience &&
        Array.isArray(this.detailsSchedule.target_audience) &&
        this.detailsSchedule.target_audience.length > 0
      );
    },
    hasReasonCancellation() {
      return this.isCanceled && this.detailsSchedule?.reason_cancellation;
    },
  },
  mounted() {
    const params = this.$route.params;
    const hasIds = params?.id && params?.idSchedule;

    if (hasIds) {
      const objScheduleIds = { id: params.id, idSchedule: params.idSchedule };
      this.consultProfessionalSchedules(objScheduleIds);
    }
  },
  methods: {
    ...mapActions(["getSlugify"]),
    ...mapActions("Professional", [
      "consultProfessionalSchedules",
      "editSchedule",
    ]),
    async sendWhatsAppProfessional() {
      const number = this.detailsSchedule.professional_number_whats_app;
      const regexNumber = /[()\s-]/g;
      const numberFormatted = `55${number.replace(regexNumber, "")}`;
      const professionalName =
        this.detailsSchedule.professional_code_name ??
        this.detailsSchedule.professional_name;
      const professionalId = this.detailsSchedule.id_professional;
      const slug = await this.getSlugify(professionalName);

      const patient = this.detailsSchedule.user_name;
      const scheduleFormatted = this.$options.filters.dateTimeFormat(
        this.detailsSchedule.schedule_date_time
      );
      const serviceSlotTime = this.$options.filters.timeFormat(
        this.detailsSchedule.service_slot_time
      );
      const priceForSession = `${this.$options.filters.money(
        this.detailsSchedule.price
      )} - ${this.getSessionWithText}`;
      const urlGoogleMeet = this.detailsSchedule.url_google_meet;
      const reasonConsultation = this.detailsSchedule.reason_consultation;
      const patientNumberWhatsApp = this.detailsSchedule.user_number_whats_app;
      const idSchedule = this.detailsSchedule.id;
      const urlScheduleEvolution = `https://evolutionsaudemental.com/psicologo/${professionalId}/${slug}/agenda/${idSchedule}`;

      const message =
        `*👩🏻‍⚕️👨🏻‍⚕️ Olá, ${professionalName.trim()}*, você tem um novo agendamento de consulta no Evolution.\n\n` +
        `*👩🏽‍💼👨🏽‍💼 Paciente: ${patient.trim()}*\n\n` +
        `*🕐 Dia e horário: ${scheduleFormatted}*\n\n` +
        `*⏱️ Tempo de consulta: ${serviceSlotTime}*\n\n` +
        `*💵 Preço por sessão: ${priceForSession}*\n\n` +
        `*${this.getIconStatus} Status: ${this.textStatus}*\n\n` +
        `*🔗 Link do Google Meet da consulta: ${urlGoogleMeet}* \n\n` +
        `*💬 Motivo da consulta:* ${reasonConsultation}\n\n` +
        `*📞 WhatsApp do Paciente: ${patientNumberWhatsApp}* \n\n` +
        `🌐 Você pode acessar os detalhes da consulta pelo o link: *${urlScheduleEvolution}*.\n\n` +
        `Quaisquer dúvidas a equipe do Evolution está a disposição.`;
      const encodedMessage = encodeURIComponent(message);
      const urlApiWhatsApp = "https://api.whatsapp.com/send?";

      window.open(
        `${urlApiWhatsApp}phone=${numberFormatted}&text=${encodedMessage}`,
        "_blank",
        "noopener"
      );
    },
    sendWhatsAppUser() {
      const number = this.detailsSchedule.user_number_whats_app;
      const regexNumber = /[()\s-]/g;
      const numberFormatted = `55${number.replace(regexNumber, "")}`;
      const professionalName =
        this.detailsSchedule.professional_code_name ??
        this.detailsSchedule.professional_name;

      const patient = this.detailsSchedule.user_name;
      const patientId = this.detailsSchedule.id_user;
      const scheduleFormatted = this.$options.filters.dateTimeFormat(
        this.detailsSchedule.schedule_date_time
      );
      const serviceSlotTime = this.$options.filters.timeFormat(
        this.detailsSchedule.service_slot_time
      );
      const priceForSession = `${this.$options.filters.money(
        this.detailsSchedule.price
      )} - ${this.getSessionWithText}`;
      const urlGoogleMeet = this.detailsSchedule.url_google_meet;
      const reasonConsultation = this.detailsSchedule.reason_consultation;
      const professionalNumberWhatsApp =
        this.detailsSchedule.professional_number_whats_app;
      const idSchedule = this.detailsSchedule.id;
      const urlScheduleEvolution = `https://evolutionsaudemental.com/paciente/${patientId}/agenda/${idSchedule}`;

      const message =
        `*👩🏽‍💼👨🏽‍💼 Olá, ${patient.trim()}*, você realizou um novo agendamento de consulta no Evolution.\n\n` +
        `*👩🏻‍⚕️👨🏻‍⚕️ Profissional: ${professionalName.trim()}*\n\n` +
        `*🕐 Dia e horário: ${scheduleFormatted}*\n\n` +
        `*⏱️ Tempo de consulta: ${serviceSlotTime}*\n\n` +
        `*💵 Preço por sessão: ${priceForSession}*\n\n` +
        `*${this.getIconStatus} Status: ${this.textStatus}*\n\n` +
        `*🔗 Link do Google Meet da consulta: ${urlGoogleMeet}* \n\n` +
        `*💬 Motivo da consulta:* ${reasonConsultation}\n\n` +
        `*📞 WhatsApp do Psicólogo(a): ${professionalNumberWhatsApp}* \n\n` +
        `🌐 Você pode acessar os detalhes da consulta pelo o link: *${urlScheduleEvolution}*.\n\n` +
        `Quaisquer dúvidas a equipe do Evolution está a disposição.`;
      const encodedMessage = encodeURIComponent(message);
      const urlApiWhatsApp = "https://api.whatsapp.com/send?";

      window.open(
        `${urlApiWhatsApp}phone=${numberFormatted}&text=${encodedMessage}`,
        "_blank",
        "noopener"
      );
    },
    sendDialogDefault(type, message, showBtns = true, showTimer = false) {
      let objFire = {
        html: message,
        icon: type,
        showConfirmButton: showBtns,
        showCancelButton: showBtns,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#EF0000",
        confirmButtonText: "SIM",
        cancelButtonText: "NÃO",
      };

      if (showTimer) {
        objFire = {
          ...objFire,
          timer: 3000,
          timerProgressBar: true,
        };
      }

      return this.$swal.fire(objFire);
    },
    async handleClickStatus(type) {
      const statusSchedule = {
        needsAction: "marcar como pendente",
        declined: "cancelar",
        accepted: "confirmar",
        concluded: "concluir",
      };
      const statusMessage = statusSchedule[type];

      const messageDialog = `Tem certeza que deseja <b>${statusMessage}</b> a consulta com o paciente <b>${this.detailsSchedule.user_name}?</b>`;
      const dataDialog = await this.sendDialogDefault("warning", messageDialog);

      if (dataDialog?.isConfirmed) {
        const objSchedule = {
          id_schedule: this.detailsSchedule.id,
          id_schedule_event: this.detailsSchedule.id_schedule_event,
          id_professional: this.detailsSchedule.id_professional,
          id_user: this.detailsSchedule.id_user,
          type: type,
        };

        const { data } = await this.editSchedule(objSchedule);

        if (data?.success) {
          const statusScheduleNotification = {
            needsAction: "marcada como pendente",
            declined: "cancelada",
            accepted: "confirmada",
            concluded: "concluída",
          };
          const statusNotification = statusScheduleNotification[type];
          const message = `Sua consulta com o paciente <b>${this.detailsSchedule.user_name}</b> foi <b>${statusNotification}</b>.`;
          this.sendDialogDefault("success", message, false);

          const params = this.$route.params;
          const hasIds = params?.id && params?.idSchedule;

          if (hasIds) {
            const objScheduleIds = {
              id: params.id,
              idSchedule: params.idSchedule,
            };
            await this.consultProfessionalSchedules(objScheduleIds);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.details-schedule {
  &__header {
    border-bottom: 1px solid var(--gray-1);
    padding-bottom: 10px;
    .card-list-status {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 10px;
      border-bottom: 1px solid var(--gray-1);
      margin-bottom: 10px;

      @media (max-width: 991px) {
        flex-direction: column;
        gap: 20px;
      }

      .change-status {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;

        &__btn {
          padding: 5px 20px;
          background: var(--orange);
          border: 0;
          border-radius: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;

          @media (max-width: 991px) {
            padding: 5px 10px;
          }

          &--concluded {
            background: var(--green);
          }
          &--confirmed {
            background: var(--blue);
          }
          &--canceled {
            background: var(--red-2);
          }
          p {
            font-size: 14px;
            font-family: "Font Bold";
            color: var(--white);
            margin-bottom: 0;

            @media (max-width: 991px) {
              font-size: 12px;
            }
          }

          svg {
            @media (max-width: 991px) {
              width: 14px;
              height: 14px;
            }
          }
        }
      }
      .card-list-schedule-status {
        padding: 5px 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--orange);
        border-radius: 10px;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.16);
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--white);
        @media (max-width: 991px) {
          font-size: 14px;
          padding: 5px 10px;
        }
        &--concluded {
          background: var(--green);
        }
        &--confirmed {
          background: var(--blue);
        }
        &--canceled {
          background: var(--red-dark);
        }
      }
    }
    .card-list-information {
      display: flex;
      align-items: flex-start;
      .card-list-schedule {
        &-status {
          padding: 5px 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--orange);
          border-radius: 10px;
          box-shadow: 0 1px 1px rgba(0, 0, 0, 0.16);
          font-size: 16px;
          font-family: "Font Semibold";
          color: var(--white);
          @media (max-width: 991px) {
            font-size: 14px;
            padding: 5px 10px;
          }
          &--concluded {
            background: var(--green);
          }
          &--confirmed {
            background: var(--blue);
          }
          &--canceled {
            background: var(--red-dark);
          }
        }
        &-detail {
          display: flex;
          align-items: flex-start;
          border-bottom: 1px solid var(--gray-1);
          padding-bottom: 10px;
        }
        &__div {
          width: 50%;
          &:first-child {
            padding-right: 20px;
          }
          &:last-child {
            border-left: 1px solid var(--gray-1);
            padding-left: 20px;
          }
        }
        &__type {
          font-size: 16px;
          font-family: "Font Semibold";
          color: var(--black);
          text-align: left;
          margin-bottom: 10px;
          @media (max-width: 991px) {
            font-size: 14px;
          }
        }
        &__element {
          display: flex;
          align-items: center;
          gap: 15px;
        }
        &__photo {
          img {
            border-radius: 100%;
            max-width: 60px;
            max-height: 60px;
            object-fit: cover;
            @media (max-width: 991px) {
              max-width: 50px;
              max-height: 50px;
            }
          }
        }
        &__information {
          text-align: left;
        }
        &__title {
          font-size: 16px;
          font-family: "Font Semibold";
          color: var(--black);
          margin-bottom: 0;
          @media (max-width: 991px) {
            font-size: 14px;
          }
        }
      }
    }
  }
  &__body {
    padding-top: 15px;
    padding-bottom: 50px;
    text-align: left;
  }
  &-hour,
  &-specialties,
  &-price,
  &-whatsapp,
  &-meet,
  &-target-audience,
  &-report,
  &-reason-cancellation {
    padding: 15px 0;
    h2 {
      font-size: 24px;
      font-family: "Font Semibold";
      color: var(--black);
      margin-bottom: 20px;
      @media (max-width: 991px) {
        font-size: 16px;
      }
    }
    &__info {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 10px;
      img,
      svg {
        max-width: 32px;
        @media (max-width: 991px) {
          max-width: 20px;
        }
      }
      p {
        font-size: 18px;
        font-family: "Font Light";
        color: var(--black);
        margin-bottom: 0;
        @media (max-width: 991px) {
          font-size: 14px;
        }
      }
    }
  }
  &__reason {
    padding: 15px 0;
    h2 {
      font-size: 24px;
      font-family: "Font Semibold";
      color: var(--black);
      margin-bottom: 20px;
      @media (max-width: 991px) {
        font-size: 16px;
      }
    }
    p {
      font-size: 16px;
      font-family: "Font Regular";
      color: var(--gray-dark);
      margin-bottom: 0;
      @media (max-width: 991px) {
        font-size: 14px;
      }
    }
  }
  &-specialties {
    &__body {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 15px;
    }
    &__item {
      padding: 5px 20px;
      background: var(--white);
      border: 1px solid var(--green);
      border-radius: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-family: "Font Regular";
      color: var(--black);
    }
  }
  &-whatsapp {
    &__btn {
      width: 100%;
      max-width: 200px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      background: #25d366;
      border: 0;
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.16);
      border-radius: 30px;
      transition: 500ms;
      img {
        max-width: 24px;
      }
      p {
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--white);
        margin-bottom: 0;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
  &-meet {
    &__btn {
      .btn-google-meet {
        max-width: 225px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background: var(--white);
        box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.16);
        border-radius: 30px;
        @media (max-width: 991px) {
          font-size: 14px;
          max-width: 190px;
          height: 40px;
        }
        p {
          font-size: 16px;
          font-family: "Font Light";
          color: var(--black);
          margin-bottom: 0;
          @media (max-width: 991px) {
            font-size: 14px;
          }
        }
      }
    }
  }
  &-target-audience {
    &__body {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 15px;
    }
    &__item {
      padding: 5px 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--blue);
      border: 1px solid var(--blue);
      border-radius: 30px;
      font-size: 12px;
      font-family: "Font Bold";
      color: var(--white);
    }
  }
  &-report {
    &__public,
    &__private {
      padding: 20px;
      @media (max-width: 991px) {
        padding: 20px 10px;
      }
      h3 {
        font-size: 16px;
        font-family: "Font Semibold";
        color: var(--black);
        @media (max-width: 991px) {
          font-size: 14px;
        }
      }
      p {
        font-size: 14px;
        font-family: "Font Regular";
        color: var(--gray-dark);
        margin-bottom: 0;
        @media (max-width: 991px) {
          font-size: 12px;
        }
      }
    }
  }
  &-reason-cancellation {
    p {
      font-size: 16px;
      font-family: "Font Regular";
      color: var(--gray-dark);
      margin-bottom: 0;
      @media (max-width: 991px) {
        font-size: 14px;
      }
    }
  }
}
</style>
